import {FC} from 'react'

import {BreadcrumbStep} from '@/app/lib/structuredData'
import {Breadcrumbs} from '@/components/common/content/Breadcrumbs'

type TrademarkDisputesBreadcrumbsProps = {
  trail: BreadcrumbStep[]
}

export const TrademarkDisputesBreadcrumbs: FC<TrademarkDisputesBreadcrumbsProps> = ({trail}) => (
  <Breadcrumbs
    trail={trail}
    // The h1 directly below names the current page.
    hideCurrent
  />
)
